import React, { Component } from 'react';
import styles from '../Forms/FormStyles.module.scss'

class FormPage extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <>
                <div className={!this.props.modal ? styles.backgroundWrap : undefined}>
                    {
                        !this.props.modal &&
                        <div className={styles.cloudBG} />
                    }
                    <div className={`${styles.formWrap} ${this.props.is === "login" && styles.islogin} ${this.props.is === "checkout" && styles.ischeckout} text-center`}>
                        {this.props.children}
                    </div>
                </div>
                {
                    !this.props.modal &&
                    <div className={styles.cityScape} />
                }
            </>
        );
    }
}

export default FormPage;
